export const reviews = [
  {
    id: 1,
    author: "Daan van Dijk",
    role: "Rotterdam",
    rating: 5,
    date: { nl: "3 dagen geleden", en: "3 days ago", tr: "3 gün önce" },
    service: { nl: "Aura Hair Full Grooming", en: "Aura Hair Full Grooming", tr: "Aura Hair Full Bakım" },
    comment: {
      nl: "Beste kapper in Rotterdam Alexander! De stylisten nemen echt de tijd voor je en hebben oog voor elk detail. De sfeer in de salon is top en de koffie staat altijd klaar.",
      en: "Best salon in Rotterdam Alexander! The stylists take their time and pay great attention to detail. Great vibe and excellent coffee.",
      tr: "Rotterdam Alexander'daki en iyi salon! Kuaförler gerçekten özenle ilgileniyor ve her detaya dikkat ediyor. Ortam harika, kahve ikramı kusursuz."
    },
    avatar: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=150&auto=format&fit=crop&q=80"
  },
  {
    id: 2,
    author: "Emre Kaya",
    role: "Rotterdam",
    rating: 5,
    date: { nl: "1 week geleden", en: "1 week ago", tr: "1 hafta önce" },
    service: { nl: "Skin Fade & Baarddesign", en: "Skin Fade & Beard Sculpt", tr: "Skin Fade & Sakal Tasarımı" },
    comment: {
      nl: "Vakmanschap ten top! De fade en baardlijnen worden uiterst strak en symmetrisch gezet. Zonder twijfel de beste kapper aan het Samuel Esmeijerplein.",
      en: "Master craftsmanship! The fade and beard lines are razor-sharp and symmetrical. Absolutely the best spot at Samuel Esmeijerplein.",
      tr: "Aura Hair ekibi işinin gerçekten ehli. Fade ve sakal çizgilerini kusursuz yapıyor. Samuel Esmeijerplein'deki en iyi kuaför, kesinlikle tavsiye ederim."
    },
    avatar: "https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?w=150&auto=format&fit=crop&q=80"
  },
  {
    id: 3,
    author: "Lars Bakker",
    role: "Capelle a/d IJssel",
    rating: 5,
    date: { nl: "2 weken geleden", en: "2 weeks ago", tr: "2 hafta önce" },
    service: { nl: "Signature Knippen & Wassen", en: "Signature Haircut & Wash", tr: "Özel Kesim & Yıkama" },
    comment: {
      nl: "Super vriendelijk team, strakke fade en geen lange wachttijden. Handig dat je online kunt reserveren en voor de deur gratis kunt parkeren!",
      en: "Super friendly team, clean fade and zero waiting time with an online appointment. Free parking right at the door is a huge bonus!",
      tr: "Çok samimi bir ekip, harika bir saç kesimi ve randevuyla gittiğinizde hiç beklemiyorsunuz. Online randevu ve kapıda otopark çok pratik!"
    },
    avatar: "https://images.unsplash.com/photo-1527980965255-d3b416303d12?w=150&auto=format&fit=crop&q=80"
  },
  {
    id: 4,
    author: "Sem de Jong",
    role: "Rotterdam",
    rating: 5,
    date: { nl: "3 weken geleden", en: "3 weeks ago", tr: "3 hafta önce" },
    service: { nl: "Hot Towel Baardscheren", en: "Hot Towel Straight Razor Shave", tr: "Sıcak Havlu Tıraş Ritüeli" },
    comment: {
      nl: "Heerlijke hot towel behandeling en open scheermes ervaring. Je voelt je als herboren. Vaste klant geworden bij Aura Hair!",
      en: "Wonderful hot towel treatment and straight razor shave. You feel rejuvenated. Aura Hair has earned a loyal client!",
      tr: "Sıcak havlu kompresi ve çelik ustura deneyimi harika. İnsan koltuktan dinlenmiş kalkıyor. Artık düzenli müşterisiyim!"
    },
    avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&auto=format&fit=crop&q=80"
  }
];
